/**
 * Persistente Portal-Session für PWA / „Als App installieren“.
 * Liest zuerst localStorage; migriert einmalig aus sessionStorage.
 */

const TOKEN_KEY = 'portal_token';
const USER_KEY = 'portal_user';

function _migrateFromSession(key) {
  try {
    const fromSession = sessionStorage.getItem(key);
    if (fromSession && !localStorage.getItem(key)) {
      localStorage.setItem(key, fromSession);
      sessionStorage.removeItem(key);
    }
  } catch (_) { /* private mode */ }
}

export function getPortalToken() {
  _migrateFromSession(TOKEN_KEY);
  try {
    return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY) || null;
  } catch (_) {
    return null;
  }
}

export function getPortalUser() {
  _migrateFromSession(USER_KEY);
  try {
    const raw = localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}

export function getPortalUserRaw() {
  _migrateFromSession(USER_KEY);
  try {
    return localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY) || null;
  } catch (_) {
    return null;
  }
}

export function setPortalSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, typeof user === 'string' ? user : JSON.stringify(user));
  try {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
  } catch (_) { /* */ }
}

export function clearPortalSession() {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
  } catch (_) { /* */ }
}

export function isPortalPath(pathname = window.location.pathname) {
  return typeof pathname === 'string' && pathname.startsWith('/portal');
}
